module.exports = __webpack_public_path__ + "img/1_003.cb694421.jpg";